import { GeneralServiceBack } from "./generalServiceBack";

let apiInstance = null;

export function getApiService() {
  if (!apiInstance) {
    apiInstance = new GeneralServiceBack();
  }

  return apiInstance;
}
